import { MARKETING_CLICK_ID_PARAMS, type MarketingClickIds } from './types'
import {
  getMarketingClickIdsFromCookies,
  getMarketingClickIdsFromStorage,
  getMarketingClickIdsFromUrl,
  persistMarketingClickIdsToStorage,
} from './utils'

/**
 * Reads marketing click IDs in priority order: URL params (highest), then platform cookies,
 * then localStorage (30-day rolling TTL). When the URL contains click ID params, merges them into
 * storage (partial updates, preserves other keys, resets expiry); when the URL has none, storage
 * is left unchanged by persistence. Expired storage entries are cleared on read. C0004 required
 * for any localStorage read/write.
 * SSR-safe: returns empty object when not in browser.
 */
export const getMarketingClickIds = (): MarketingClickIds => {
  if (typeof window === 'undefined') {
    return {}
  }

  const url = new URL(window.location.href)
  const fromUrl = getMarketingClickIdsFromUrl(url)
  persistMarketingClickIdsToStorage(fromUrl)
  const fromStorage = getMarketingClickIdsFromStorage()
  const fromCookies = getMarketingClickIdsFromCookies()

  const result: MarketingClickIds = {}
  for (const param of MARKETING_CLICK_ID_PARAMS) {
    const value = fromUrl[param] ?? fromCookies[param] ?? fromStorage[param]
    if (value) {
      result[param] = value
    }
  }
  return result
}
